import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.promise.finally.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createCdnUrl, createCdnUrlModifiers } from '../../../utils/cdn-utils.js';
import { EditorButtonControl } from './EditorButtonControl.js';
import { FAKE_ORIGINAL_FILTER } from './EditorSlider.js';
import { COMMON_OPERATIONS, transformationsToOperations } from './lib/transformationUtils.js';
import { preloadImage } from './lib/preloadImage.js';
export class EditorFilterControl extends EditorButtonControl {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      active: false,
      title: '',
      icon: '',
      isOriginal: false,
      iconSize: '20',
      'on.click': null
    }));
  }
  _previewSrc() {
    let previewSize = parseInt(window.getComputedStyle(this).getPropertyValue('--l-base-min-width'), 10);
    let dpr = window.devicePixelRatio;
    let size = Math.ceil(dpr * previewSize);
    let quality = dpr >= 2 ? 'lightest' : 'normal';
    let filterValue = 100;

    /** @type {import('./types.js').Transformations} */
    let transformations = _objectSpread({}, this.$['*editorTransformations']);
    transformations[this._operation] = this._filter !== FAKE_ORIGINAL_FILTER ? {
      name: this._filter,
      amount: filterValue
    } : undefined;
    return createCdnUrl(this._originalUrl, createCdnUrlModifiers(COMMON_OPERATIONS, transformationsToOperations(transformations), "quality/".concat(quality), "scale_crop/".concat(size, "x").concat(size, "/center")));
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   * @param {IntersectionObserver} observer
   */
  _observerCallback(entries, observer) {
    let intersectionEntry = entries[0];
    if (intersectionEntry.isIntersecting) {
      let src = this.proxyUrl(this._previewSrc());
      let previewEl = this.ref['preview-el'];
      let {
        promise,
        cancel
      } = preloadImage(src);
      this._cancelPreload = cancel;
      promise.catch(err => {
        this.$['*networkProblems'] = true;
        console.error('Failed to load image', {
          error: err
        });
      }).finally(() => {
        previewEl.style.backgroundImage = "url(".concat(src, ")");
        previewEl.setAttribute('loaded', '');
        observer.unobserve(this);
      });
    } else {
      this._cancelPreload && this._cancelPreload();
    }
  }
  initCallback() {
    super.initCallback();
    this.$['on.click'] = e => {
      if (!this.$.active) {
        this.$['*sliderEl'].setOperation(this._operation, this._filter);
        this.$['*sliderEl'].apply();
      } else if (!this.$.isOriginal) {
        this.$['*sliderEl'].setOperation(this._operation, this._filter);
        this.$['*showSlider'] = true;
      }
      this.$['*currentFilter'] = this._filter;
    };
    this.defineAccessor('filter', filter => {
      this._operation = 'filter';
      this._filter = filter;
      this.$.isOriginal = filter === FAKE_ORIGINAL_FILTER;
      this.$.icon = this.$.isOriginal ? 'original' : 'slider';
    });
    this._observer = new window.IntersectionObserver(this._observerCallback.bind(this), {
      threshold: [0, 1]
    });
    let originalUrl = this.$['*originalUrl'];
    this._originalUrl = originalUrl;
    if (this.$.isOriginal) {
      this.ref['icon-el'].classList.add('original-icon');
    } else {
      this._observer.observe(this);
    }
    this.sub('*currentFilter', currentFilter => {
      this.$.active = currentFilter && currentFilter === this._filter;
    });
    this.sub('isOriginal', isOriginal => {
      this.$.iconSize = isOriginal ? 40 : 20;
    });
    this.sub('active', active => {
      if (this.$.isOriginal) {
        return;
      }
      let iconEl = this.ref['icon-el'];
      iconEl.style.opacity = active ? '1' : '0';
      let previewEl = this.ref['preview-el'];
      if (active) {
        previewEl.style.opacity = '0';
      } else if (previewEl.style.backgroundImage) {
        previewEl.style.opacity = '1';
      }
    });
    this.sub('*networkProblems', networkProblems => {
      if (!networkProblems) {
        let src = this.proxyUrl(this._previewSrc());
        let previewEl = this.ref['preview-el'];
        if (previewEl.style.backgroundImage) {
          previewEl.style.backgroundImage = 'none';
          previewEl.style.backgroundImage = "url(".concat(src, ")");
        }
      }
    });
  }
  destroyCallback() {
    var _this$_observer;
    super.destroyCallback();
    (_this$_observer = this._observer) === null || _this$_observer === void 0 || _this$_observer.disconnect();
    this._cancelPreload && this._cancelPreload();
  }
}
EditorFilterControl.template = /* HTML */"\n  <div class=\"before\"></div>\n  <div class=\"preview\" ref=\"preview-el\"></div>\n  <lr-icon size=\"40\" ref=\"icon-el\" set=\"@name: icon; @size: iconSize;\"></lr-icon>\n";